import React, {useEffect, useState} from "react";
import "./Address.scss";
import {useHistory, useLocation} from "react-router";
import {CityData, getAddressFromOSM, ProvinceData, SendAddress} from "./AddressService";
//import {Map} from "./Map";
import toaster from "toasted-notes";
import {ChangeDefaultAddress} from "../../Components/OnlineAddress/OnlineAddressService";
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup,useMapEvents  } from 'react-leaflet'
import L from 'leaflet';
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useResp} from "../../hooks";
import {getMallMerchant_api} from "../../Services/apis";

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function LocationMarker({getAdd}) {
    const [position, setPosition] = useState(null)
    const map = useMapEvents({
        click() {
            console.log("click")
            // map.locate()
        },
        moveend(e) {
            let cc = map.getCenter()
            getAdd(cc.lat,cc.lng)

        },
    })

    return position === null ? null : (
        <Marker position={position}>
            <Popup>You are here</Popup>
        </Marker>
    )
}

function Address({side,back}) {
    const history = useHistory();
    const location = useLocation();
    const [province,set_province] = useState([]);
    const [cities,set_cities] = useState([]);

    //form states
    const [selectedProvince,set_selectedProvince] = useState("");
    const [selectedCity,set_selectedCity] = useState("");
    const [address,set_address] = useState("");
    const [addressDetail,set_addressDetail] = useState("");
    const [zipCode,set_zipCode] = useState("");
    const [coordinate,set_coordinate] = useState({});
    const [isDefault,set_isDefault] = useState(false);
    const [loginState,set_loginState] = useState(false);
    const [merchantId,set_merchantId] = useState(null);






    useEffect(()=>{
    getMerchant()
    Province();
        // if(location && location.state && location.state.merchantId)
        //     set_merchantId(location.state.merchantId)
        setTimeout(()=>{
            window.scrollTo({left: 0, top: 0});
        },500)

    },[])


    const getMerchant = async () => {
        try {
            const res = await getMallMerchant_api()
            set_merchantId(res.data.uid)
        } catch (e) {
            console.log(e)
        }
    }

    const Province = async () =>{
        const response = await ProvinceData();
        // console.log(response.data)
        set_province(response.data);
    }

    const City = async (state) =>{
        const response = await CityData(state);
        // console.log(response.data)
        set_cities(response.data);
    }

    const provinceChange = (e) =>{
        City(e.target.value)
        set_selectedProvince(e.target.value)
    }


    const setAddress=async ()=>{
        set_loginState(true)
        let obj = {
            address:address +" , "+addressDetail,
            postal_code:zipCode,
            is_default:isDefault,
            city:selectedCity,
            coordinate:{latitude:coordinate.lat,longitude:coordinate.lng}
        }

        console.log(obj);


        if(selectedCity.length<1 || selectedCity==="0"){
            toaster.notify(({ onClose }) => (<Error   message={"شهر را انتخاب نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }

        if(address.length<1){
            toaster.notify(({ onClose }) => (<Error   message={"آدرس را تکمیل نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }

        if(addressDetail.length<1){
            toaster.notify(({ onClose }) => (<Error   message={"جزییات آدرس را تکمیل نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }



        // if(zipCode.length!==10){
        //     toaster.notify(({ onClose }) => (<Error   message={"کدپستی را بطور صحیح وارد نمایید"}/>),{duration: 2000});
        //     set_loginState(false)
        //     return ;
        // }

        if(!coordinate.lat){
            toaster.notify(({ onClose }) => (<Error   message={"موقعیت خود را بروی نقشه تعیین نمایید"}/>),{duration: 2000});
            set_loginState(false)
            return ;
        }

        // set_loginState(false)
        try{
            const response = await SendAddress(obj);
            // console.log("Response : ",response);
            set_loginState(false)
            await ChangeDefaultAddress(response.data.uid,merchantId)

            console.log("side ",side)

            if(side){
                console.log("side in ",side)
             side(false,response.data)
            }else {
                console.log("side out ",side)
                history.goBack();
            }
            console.log("side fff ",side)
        }catch (e) {
            console.log("side error ",side)
            set_loginState(false)
        }

    }


    const [position,set_position] = useState([35.6892, 51.3890])



    const myIcon = L.icon({
        // iconUrl: 'https://www.pngall.com/wp-content/uploads/2017/05/Map-Marker-PNG-HD.png',
        iconUrl: '/other/marker_open.png',
        iconSize: [64,64],
        iconAnchor: [32, 64],
        popupAnchor: null,
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null
    });


    const { height, width,mobileWidth } = useWindowDimensions();



    const [map, setMap] = useState(null)


    const getAddress = async (lat,lng)=>{
        let osmAddress = await getAddressFromOSM(lat,lng)
        let calcAddress = osmAddress.data[0].display_name;
        calcAddress =  calcAddress.split(",")
        calcAddress = calcAddress.slice(0, -5);
        let reverse = calcAddress.reverse();
        set_address(reverse.toString())
        set_position([lat,lng])
        set_coordinate({lat,lng})
    }

    const resp = useResp()

    return(
        <div>

            {!resp? <div className="online-header-section" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>

                {back?<i className="fa fa-arrow-left"
                         onClick={()=>{
                             history.goBack()
                         }}
                ></i>:null}
                <span>افزودن آدرس</span>
            </div>:null}



            <div className="online-address-container" >


                {/*<div className="online-address-row">*/}
                {/*    <div className="online-address-item">*/}
                {/*        <span><span className="mandatory-badg">*</span>موقعیت مکانی </span>*/}
                {/*        /!*<input type="text" name="" id="" placeholder="موقعیت مکانی"/>*!/*/}
                {/*    </div>*/}
                {/*</div>*/}


                <div className="address-title-sec">
                    <span>مکان خود را بروی نقشه مشخص نمایید</span>
                </div>

                <div className="osm-sec">
                    <div className="osm-custom-flag">
                        <img src="/other/marker_open.png" alt=""/>
                    </div>
                    <MapContainer
                        center={position}
                        zoom={13}>
                        ref={setMap}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
                        />
                        <LocationMarker getAdd={getAddress} />
                        {/*{ position && <Marker*/}
                        {/*    eventHandlers={{*/}
                        {/*        dragend: (e) => {*/}
                        {/*            console.log('marker clicked', e.target._latlng)*/}
                        {/*            let {lng,lat}= e.target._latlng;*/}
                        {/*            set_position([lat,lng])*/}
                        {/*            set_coordinate({lat,lng})*/}
                        {/*        },*/}
                        {/*    }}*/}
                        {/*    icon={myIcon}*/}
                        {/*    position={position} draggable={true}>*/}
                        {/*</Marker>}*/}
                        {/*<Marker*/}
                        {/*    position={position}*/}
                        {/*    icon={myIcon}*/}
                        {/*    onClick={e=>{*/}
                        {/*        console.log("click",e)*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <Popup>*/}
                        {/*        <span>A pretty CSS3 popup. <br/> Easily customizable.</span>*/}
                        {/*    </Popup>*/}
                        {/*</Marker>*/}


                    </MapContainer>

                </div>


                <div className="online-address-row-sec">
                    <div className="online-address-row" style={side?{flexDirection:'row-reverse'}:{flexDirection:'row'}}>
                        <div className="online-address-item" >
                            <span><span className="mandatory-badg">*</span> شهر</span>
                            <select
                                value={selectedCity}
                                onChange={e=>set_selectedCity(e.target.value)}
                                name="" id="">
                                <option value="0">انتخاب شهر</option>
                                {cities.map(item=>{
                                    return(
                                        <option value={item.uid}>{item.title}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="online-address-item">
                            <span><span className="mandatory-badg">*</span>استان </span>
                            <select
                                value={selectedProvince}
                                onChange={provinceChange}
                                name="" id="">
                                <option value="0">انتخاب استان</option>
                                {province.map(item=>{
                                    return(
                                        <option value={item.uid}>{item.title}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>

                    <div className="online-address-row">
                        <div className="online-address-item">
                            <span><span className="mandatory-badg">*</span> آدرس </span>
                            <textarea
                                value={address}
                                onChange={e=>set_address(e.target.value)}
                                name="" id="" cols="30" rows="3" placeholder="آدرس">
                        </textarea>
                        </div>
                    </div>

                    <div className="online-address-row">
                        <div className="online-address-item">
                            <span><span className="mandatory-badg">*</span> جزییات آدرس </span>
                            <textarea
                                value={addressDetail}
                                onChange={e=>set_addressDetail(e.target.value)}
                                name="" id="" cols="30" rows="3" placeholder="جزییات آدرس مثل پلاک , واحد , طبقه">
                        </textarea>
                        </div>
                    </div>

                    <div className="online-address-row">
                        <div className="online-address-item">
                            <span> کد پستی </span>
                            <input
                                value={zipCode}
                                onChange={e=>set_zipCode(e.target.value)}
                                type="text" name="" id="" placeholder="کد پستی"/>
                        </div>
                    </div>


                </div>





                {/*<Map coordinate={set_coordinate}/>*/}

                <div className="online-address-row">
                    <div className="online-address-item-flat">
                        <input
                            onClick={()=>{
                                set_isDefault(!isDefault)
                            }}
                            type="checkbox" name="" id="" checked={isDefault}/>
                        <span>آدرس اصلی</span>
                    </div>
                </div>

                {!resp?<div className="online-address-row">
                    <div className="online-address-btn" onClick={setAddress}>
                        {loginState?<i className="fa fa-spinner fa-spin"></i>: null}
                        ثبت
                    </div>
                </div>:
                <>
                    <div className="add-address-sec">
                        <span className="add-address-btn" onClick={setAddress}>
                             {loginState?<i className="fa fa-spinner fa-spin"></i>: null}
                            ثبت</span>
                    </div>
                    <br/><br/><br/>
                </>
                }


            </div>
        </div>
    )
}


export {Address};

